import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'

import { SharedModule } from '../shared/shared.module'
import { DisclaimersComponent } from './components/disclaimers/disclaimers.component'
import { FootnotesComponent } from './components/footnotes/footnotes.component'
import { DisclosuresComponent } from './disclosures.component'

@NgModule({
  declarations: [
    DisclosuresComponent,
    FootnotesComponent,
    DisclaimersComponent,
  ],
  imports: [CommonModule, SharedModule],
  exports: [DisclosuresComponent],
  providers: [],
})
export class DisclosuresModule {}
